import { IFavoritesState } from '../../types/favorites';

const defaultState: IFavoritesState = {
  count: 0,
};

export function favoritesReducer(state: IFavoritesState = defaultState): IFavoritesState {
  return state;
}
